import { useEffect, useState } from "react";
import TopBar from "./components/TopBar";
import HeroSection from "./components/HeroSection";
import ValuesSection from "./components/ValuesSection";
import BusinessSection from "./components/BusinessSection";
import GuaranteeSection from "./components/GuaranteeSection";
import CollabBanner from "./components/CollabBanner";
import ActivitySection from "./components/ActivitySection";
import ServiceSection from "./components/ServiceSection";
import ComplaintSection from "./components/ComplaintSection";
import {
  getSiteSettings, fetchSiteSettings,
  getActivitySettings, fetchActivitySettings,
} from "@/mocks/adminData";
import { warmupVerifyCache } from "@/hooks/useGuaranteeVerify";
import type { SiteSettings, ActivitySettings } from "@/mocks/adminData";

export default function Home() {
  // 先用缓存/默认值立即渲染，再异步拉数据库最新数据
  const [settings, setSettings] = useState<SiteSettings>(getSiteSettings());
  const [activitySettings, setActivitySettings] = useState<ActivitySettings>(getActivitySettings());

  useEffect(() => {
    // 并行拉取所有数据，互不阻塞
    fetchSiteSettings().then(setSettings);
    fetchActivitySettings().then(setActivitySettings);

    // 预热担保验证缓存（拉取最新 partners 列表到本地）
    // 这样用户点验证时可以立即从本地缓存得到结果，无需等待网络
    warmupVerifyCache();
  }, []);

  const footerTg = settings.footer_tg || "@hx_zs888";
  const footerTgUrl = `https://t.me/${footerTg.replace("@", "")}`;
  const footerCopyright = settings.footer_copyright || "众兴集团 © 2024  |  663.com";
  const logoImage = settings.logo_image || "https://www.au2p0rz.vip/assets/logo-hx-BTyYeU-t.webp";

  return (
    <div className="min-h-screen" style={{ background: "#eef2f7" }}>
      <TopBar settings={settings} />
      <main>
        <HeroSection settings={settings} />
        <ValuesSection settings={settings} />
        <BusinessSection />
        <GuaranteeSection />
        <CollabBanner settings={settings} />
        <ActivitySection settings={activitySettings} />
        <ServiceSection settings={settings} />
        <ComplaintSection settings={settings} />
      </main>

      {/* Footer */}
      <footer className="w-full border-t border-gray-200 py-5" style={{ background: "#dde4ee" }}>
        <div className="max-w-6xl mx-auto px-4 md:px-8 lg:px-10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="flex items-center gap-2">
            <img
              src={logoImage}
              alt="HX"
              className="w-8 h-8 object-contain"
              onError={(e) => { (e.target as HTMLImageElement).style.display = "none"; }}
            />
            <span className="text-sm text-gray-500">{footerCopyright}</span>
          </div>
          <a
            href={footerTgUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-sky-500 transition-colors cursor-pointer"
          >
            <i className="ri-telegram-fill text-sky-500 text-base"></i>
            <span>{footerTg}</span>
          </a>
        </div>
      </footer>

      {/* FAB - 投诉建议 */}
      <a
        href={settings.complaint_tg_url || "https://t.me/hx_zs888"}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-4 md:right-8 bg-gradient-to-r from-red-500 to-orange-400 text-white text-xs font-medium px-4 py-2.5 rounded-full hover:opacity-90 transition-opacity cursor-pointer whitespace-nowrap z-50 flex items-center gap-1"
      >
        <i className="ri-customer-service-2-line text-sm"></i>
        投诉建议
      </a>
    </div>
  );
}
